/**
 * testimonial-list
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_testimonial-list.css';
import './_testimonial-list.twig';

// Testimonial list uses slick slider for the desktop and mobile displays.
require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

export const name = 'testimonial-list';

export const defaults = {
  dummyClass: 'js-testimonial-list-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { testimonialList = {} }) {
  // Find our component within the DOM

  // eslint-disable-next-line no-undef
  const testimonialLists = once(
    'testimonial-list--init',
    '.testimonial-list',
    $context
  );

  // Bail if component does not exist
  if (!testimonialLists.length) {
    return;
  }
  const $testimonialList = $(testimonialLists);

  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...testimonialList,
  };

  // Adds slick slider functionality.
  $testimonialList.each(function initializeSlickSlider() {
    const time = $(this).data('slide-time');
    $('.testimonial-list__testimonials', this).slick({
      arrows: true,
      appendArrows: '.testimonial-list__actions',
      appendDots: '.testimonial-list__actions',
      autoplay: true,
      autoplaySpeed: time,
      dots: true,
      infinite: true,
    });
  });
}
export default enable;
